import { FunctionComponent } from "react";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Highlight from "../../../components/highlight";
import HeadingContainer from "../../../layout/heading-container";
import { BodyLargeRegular, TitleLarge } from "../../../components/font";
import { OptionTile, tokens } from "@manifesthhqinc/ui-library";
import { OptionFormContainer } from "../../../layout/container/OptionFormContainer";

const HaveAccountStatementScreen: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const { currentSourceAccountStep, currentOldAccountDetails, updateOldAccountDetails } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer paneVariant="optionForm" withProgressBar>
            <TitleLarge>
              Do you have a recent account statement from <Highlight>{currentOldAccountDetails.planSponsor}</Highlight>?
            </TitleLarge>
            <BodyLargeRegular $color={tokens.color.text.secondary}>
              This helps us verify your account details. Provide what you can, and Manifest will take care of the rest.
            </BodyLargeRegular>
          </HeadingContainer>
          <OptionFormContainer>
            <OptionTile
              variant="clickthrough"
              appearance="secondary"
              supportingText="I’ll check my old provider’s portal (like TIAA or Fidelity) for my statement."
              onClick={() =>
                updateOldAccountDetails({
                  statementSkipped: "FALSE",
                })
              }
              name="hasStatement"
            >
              Yes, I do
            </OptionTile>
            <OptionTile
              onClick={() =>
                updateOldAccountDetails({
                  statementSkipped: "TRUE",
                })
              }
              name="noStatement"
              variant="clickthrough"
              appearance="secondary"
              supportingText="I’ll share a few details with Manifest to find my old account."
            >
              No, I do not
            </OptionTile>
          </OptionFormContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};

export default HaveAccountStatementScreen;
